import { AxiosError } from 'axios'
import { useRouter } from 'next/router'
import { useMutation, UseMutationOptions } from 'react-query'
import { uploadImageApi } from './upload-image.api'

import { UploadImageOptions, UploadImageResponse } from './upload-image.types'

export const useMutationUploadImage = (
  options?: UseMutationOptions<
    UploadImageResponse,
    AxiosError,
    { file: File; options?: UploadImageOptions }
  >
) => {
  const { locale } = useRouter()
  const mutation = useMutation(async (requestBody) => {
    const formData = new FormData()
    formData.append('image', requestBody.file)

    const { isAvatar, isWatermark, isMarketProjectImage } =
      requestBody.options ?? {}

    formData.append('isAvatar', String(!!isAvatar))

    formData.append('isWatermark', String(!!isWatermark))

    formData.append('isMarketProjectImage', String(!!isMarketProjectImage))

    return uploadImageApi.uploadImage(formData, locale)
  }, options)

  return mutation
}

export const useMutationUploadImages = (
  options?: UseMutationOptions<
    UploadImageResponse[],
    AxiosError,
    { files: File[]; options?: UploadImageOptions }
  >
) => {
  const { locale } = useRouter()
  const mutation = useMutation(async (requestBody) => {
    if (!requestBody.files.length) {
      return []
    }

    const formData = new FormData()
    requestBody.files.forEach((file) => formData.append('images[]', file))

    const { isAvatar, isWatermark, isMarketProjectImage } =
      requestBody.options ?? {}

    formData.append('isAvatar', String(!!isAvatar))

    formData.append('isWatermark', String(!!isWatermark))

    formData.append('isMarketProjectImage', String(!!isMarketProjectImage))

    return uploadImageApi.uploadImages(formData, locale)
  }, options)

  return mutation
}
